import { NavLink } from 'react-router-dom';
import ArticleSidebar from "../components/ArticleSidebar";
import '../style/sanity_testing.css';
export default function SanityTesting  () {
  return (
    <section className="sanity-tutorial">

          {/* FIXED SIDEBAR - Now a direct child of the section */}
      <ArticleSidebar />

      {/* SCROLLING CONTENT */}
      <article className="sanity-container">
        <header className="entry-header">
    <h1><i className="fa-solid fa-brain"></i> What is Sanity Testing?</h1>
        </header>

      <div className="post-content">
       
                    <div className="table-of-contents-block">
            <div><b>Table of contents:</b></div>
            <ul>
 <li><a href="#what-is-it">What is Sanity Testing?</a></li>
            <li><a href="#why-done">Why Sanity Testing is Done</a></li>
            <li><a href="#when-done">When Sanity Testing is Done</a></li>
            <li><a href="#how-done">How Sanity Testing is Done</a></li>
            <li><a href="#benefits">Benefits & Disadvantages</a></li>
            <li><a href="#comparison">Quick Comparison</a></li>
            <li><a href="#conclusion">Conclusion</a></li>
            </ul>
          </div>



        {/* Main Content Area */}
   
            <div className="image-banner"></div>
            
            <p className="summary-intro">
              <strong>Sanity Testing </strong> is a <strong>quick check </strong>performed after receiving a <strong>minor code change or bug fix </strong>to ensure
              that the specific functionality works correctly and that the related parts of the system are not
              broken.
            </p>
            <blockquote className="key-takeaway">
              <i className="fa-solid fa-hand-point-right"></i>
              <strong> It answers the question:</strong>
              <p> “Has this fix or new change broken anything that was working fine before?”</p>
            </blockquote>
            <p>It’s a <strong>subset of regression testing </strong> and is usually <strong>unscripted </strong>(done ad-hoc or intuitively).</p>
      

          <section id="why-done">
            <h2><i className="fa-solid fa-lightbulb"></i> Why Sanity Testing is Done</h2>
            <p>The main purpose is to:</p>
            <ul className="numbered-list">
              <li>Verify that <strong>new changes or bug fixes </strong>work as expected.</li>
              <li>Ensure that the <strong>impacted areas are still stable.</strong></li>
              <li>Save time by testing only the <strong>relevant modules</strong>, not the whole system.</li>
            </ul>
          </section>

          <section id="when-done">
            <h2><i className="fa-regular fa-clock"></i> When Sanity Testing is Done</h2>
            
            <ul className="timeline-list">
              <li>After receiving a <strong>minor build update</strong> or <strong>bug fix</strong>.</li>
              <li>After <strong>small enhancements</strong> or <strong>code tweaks</strong>.</li>
              <li>Before performing full regression testing (to check if it’s even worth running).</li>
              <li>During <strong>maintenance releases</strong> or <strong>patch deployments</strong>.</li>
            </ul>
          </section>

          <section id="how-done">
            <h2><i className="fa-solid fa-gears"></i> How Sanity Testing is Done</h2>
            <ol className="process-steps">
              <li><strong>Receive the build</strong> with specific changes or fixes.</li>
              <li><strong>Identify affected modules</strong> or functionalities.</li>
              <li><strong>Perform focused testing</strong> only on the modified parts.</li>
              <li><strong>Check for side effects </strong>on related areas.</li>
              <li>If the build <strong>passes sanity</strong>, move ahead with deeper regression or functional testing.</li>
            </ol>
            <blockquote className="example-box">
              <i className="fa-solid fa-magnifying-glass"></i>
              <strong>Example:</strong> If a bug was fixed in the “payment page,” sanity testing ensures the fix works and
              other parts of the checkout flow still behave correctly.
            </blockquote>
          </section>

          <section id="benefits">
            <h2><i className="fa-solid fa-square-check"></i> Benefits & Disadvantages</h2>
            <div className="two-column-layout">
              <div className="column-left">
                <h3>✅ Benefits</h3>
                <ul>
                  <li><strong>Quick Feedback:</strong> Confirm code changes work properly.</li>
                  <li><strong>Time-Saving:</strong> Focuses only on affected areas.</li>
                  <li><strong>Prevents Rework:</strong> Avoids effort on broken builds.</li>
                </ul>
              </div>
              <div className="column-right">
                <h3>❌ Disadvantages</h3>
                <ul>
                  <li><strong>Limited Scope:</strong> Does not cover the full application.</li>
                  <li><strong>Unscripted:</strong> Informal nature makes tracking harder.</li>
                  <li><strong>Misses Hidden Issues:</strong> Minor regressions elsewhere may be missed.</li>
                </ul>
              </div>
            </div>
          </section>

          <section id="comparison">
            <h2><i className="fa-solid fa-chart-simple"></i> Quick Comparison: Sanity vs. Smoke</h2>
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Smoke Testing</th>
                  <th>Sanity Testing</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Purpose</td>
                  <td>Check build stability</td>
                  <td>Check bug fixes & new changes</td>
                </tr>
                <tr>
                  <td>Scope</td>
                  <td>Broad (core functions)</td>
                  <td>Narrow (specific area)</td>
                </tr>
                <tr>
                  <td>Automation</td>
                  <td>Often automated</td>
                  <td>Usually manual</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section id="conclusion">
            <h2>🏁 Conclusion</h2>
            <ul>
              <li><strong>Sanity Testing </strong>is a <strong>focused, quick validation</strong>.</li>
              <li>It acts as a <strong>confidence check</strong> after modifications.</li>
              <li>It complements <strong>Smoke Testing</strong> to maintain overall quality.</li>
            </ul>
          </section>
      
      </div>
 
   {/* Post Metadata Footer */}
          <footer className="fusion-meta-info">
            <div className="fusion-meta-info-wrapper">
              By <span className="fn"><a href="#author">Manish Kumar</a></span>
              <span className="fusion-inline-sep">|</span>
              <span>February 28th, 2026</span>
              <span className="fusion-inline-sep">|</span>
              <a href="#category">QA Resources</a>
            </div>
          </footer>
  
          {/* Sharing Box */}
          <div className="sharing-box">
            <h4>Share This Story, Choose Your Platform!</h4>
            <div className="fusion-social-networks">
   
      <NavLink to="https://www.linkedin.com/in/qa-coder-708418404/" target="_blank" rel="noreferrer" className="linkedin">
        <i className="fab fa-linkedin-in"></i>
      </NavLink>
      <NavLink to="https://wa.me/918299775823" target="_blank" rel="noreferrer" className="whatsapp">
        <i className="fab fa-whatsapp"></i>
      </NavLink>
      <NavLink to="mailto:qacoder0@gmail.com" className="email">
        <i className="fas fa-envelope"></i>
      </NavLink>
  {/* Instagram */}
  <NavLink to="https://www.instagram.com/qacoder0/?hl=en" target="_blank" rel="noreferrer" className="instagram">
    <i className="fab fa-instagram instagram-gradient"></i>
  </NavLink>
  

  
    </div>
          </div>
  
        </article>
    </section>
  );
};

